import messages from './myDataExport.json' with { type: 'json' };

export const myDataExportFi: Readonly<typeof messages> = messages;
